import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    CustomerPaymentsServiceProxy,
    CustomersServiceProxy,
    SalesTransactionServiceProxy,
    CreateOrEditCustomerPaymentDto,
    FindCustomerOutputDto,
    CommonLookupServiceProxy,
    DropDownLookupDto,
    GetCustomerForEditInput,
    CustomerPaymentItemDto,
    TransactionType,
    PaymentStatus
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { result } from 'lodash-es';

@Component({
    templateUrl: './create-or-edit-customerPayment.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditCustomerPaymentComponent extends AppComponentBase implements OnInit {
    active = false;
    saving = false;
    TransactionType = TransactionType;
    paymentStatus = PaymentStatus
    customerSelectedItem: FindCustomerOutputDto;
    filterText = '';
    customerPayment: CreateOrEditCustomerPaymentDto = new CreateOrEditCustomerPaymentDto();

    customerDisplayProperty = '';
    paymentTypeName = '';
    transactions : CustomerPaymentItemDto[] = [];
    totalBalance: number;
    balanceAmount: number;
    appliedAmount: number;
    allPaymentTypes: DropDownLookupDto[];
    invId: number = 0;

    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('CustomerPayment'), '/app/sales/sales/customerPayments'),
        //new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _customerPaymentsServiceProxy: CustomerPaymentsServiceProxy,
        private _salesTransactionServiceProxy: SalesTransactionServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
        private _customerService: CustomersServiceProxy
    ) {
        super(injector);
    }

    ngOnInit(): void {
        if (this._activatedRoute.snapshot.queryParams['cid']) {

            this.invId = this._activatedRoute.snapshot.queryParams['invid'];
            this.customerPayment.customerId = this._activatedRoute.snapshot.queryParams['cid'];
            this.customerPayment.status = PaymentStatus.UnPaid;
            this.customerPayment.receiptDate = this._dateTimeService.getStartOfDay();
            this.fillDropdown();
            this._customerService.getBasicCustomerInfo(this.customerPayment.customerId)
                .subscribe(resp => {
                    this.customerSelectedItem = new FindCustomerOutputDto();
                    this.customerSelectedItem.id = this.customerPayment.id;
                    this.customerSelectedItem.displayName = resp.customerCode + "-" + resp.name;
                    
                    this.getSalesTransactions();
                });
            
        } else {
           
            this.show(this._activatedRoute.snapshot.queryParams['id']);
        }
    }


    allAppliedAmount(): void {

        //this.transactions.forEach(item => {
        //    if (item.allApplied) {
        //        value.appliedAmount = value.balanceAmount;
        //        value.applied = true;
        //    } else {
        //        value.appliedAmount = 0;
        //        value.applied = false;
        //    }
        //});

        /*vm.calculateTotalValue();*/
    }


    applyAmount(data: CustomerPaymentItemDto): void {
        if (data.applied) {
            data.appliedAmount = data.balanceAmount;
        } else {
            data.appliedAmount = 0;
        }

        this.calculateTotalValue();
    }

    calculateTotalValue(): void {

        var tempTotBalance = 0;
        var tempTotApplied = 0;

        this.transactions.forEach(val => {
            
            if (val.applied) {
                tempTotApplied += val.appliedAmount;
            }

            tempTotBalance += val.balanceAmount;
        });

       

        this.totalBalance = tempTotBalance;
        this.appliedAmount = tempTotApplied;
        this.balanceAmount = tempTotBalance - tempTotApplied;
        if (this.balanceAmount < 0) {
            this.balanceAmount = 0;
            this.totalBalance = tempTotApplied;
            this.appliedAmount = tempTotApplied;
            this.balanceAmount = this.totalBalance - this.appliedAmount;
        }

        if (this.customerPayment.paymentDiscount == undefined) this.customerPayment.paymentDiscount = 0;
        this.customerPayment.amount = this.appliedAmount - this.customerPayment.paymentDiscount ;

    }

    show(customerPaymentId?: number): void {
       
        if (!customerPaymentId) {
          
            this.customerPayment = new CreateOrEditCustomerPaymentDto();
            this.customerPayment.id = customerPaymentId;
            this.customerPayment.status = PaymentStatus.UnPaid;
            this.customerPayment.receiptDate = this._dateTimeService.getStartOfDay();
            this.customerDisplayProperty = '';
            this.paymentTypeName = '';
            this.active = true;
        } else {
            this._customerPaymentsServiceProxy.getCustomerPaymentForEdit(customerPaymentId).subscribe((result) => {
                this.customerPayment = result.customerPayment;
                
                this.transactions = result.customerPaymentItems;
                this.customerSelectedItem = new FindCustomerOutputDto();
                this.customerSelectedItem.id = this.customerPayment.customerId;
                this.customerSelectedItem.displayName = result.customerName;
                this.active = true;
                this.calculateTotalValue();
            });
        }

        this.fillDropdown();
    }

    fillDropdown(): void{

        this._commonLookupServiceProxy.getAllPaymentTypesForTableDropdown().subscribe((result) => {
            this.allPaymentTypes = result;
            if (this.customerPayment.paymentTypeId == undefined) {
                this.customerPayment.paymentTypeId = null;
            }

        });
    }

    save(status : PaymentStatus): void {
        var input = new GetCustomerForEditInput();
        input.customerPayment = this.customerPayment;
        input.customerPayment.status = status; 
        input.customerPaymentItems = this.transactions;
        input.customerPayment.paymentTypeId = this.customerPayment.paymentTypeId;
        input.customerPayment.locationId = this.appSession.user.locationId;
        /*this.customerPayment.customerId = this.customerSelectedItem.id;*/

        this._customerPaymentsServiceProxy
            .createOrEdit(input)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.customerSelectedItem = null;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/sales/customerPayments']);
            });
    }

    getCustomer(customer: FindCustomerOutputDto) {
        this.customerPayment.customerId = customer.id;
        this.getSalesTransactions();
    }

    getSalesTransactions(): void {
        this._salesTransactionServiceProxy.getSalesTransactions(
            this.customerPayment.customerId, [10, 20, 40, 50, 100], true, null).subscribe((result) => {
                //this.transactions = result;
                console.log(result);
                this.transactions = [];
                result.forEach(val => {
                    var item = new CustomerPaymentItemDto();
                    item.transactionNo = val.transactionNo;
                    item.referenceNo = val.referenceNo;
                    item.amount = val.amount;
                    item.balanceAmount = val.balanceAmount;
                    item.applied = this.invId == val.transactionId ? true : false;
                    item.appliedAmount = this.invId == val.transactionId ? val.amount : 0;
                    item.customerPaymentId = 0;
                    item.transactionDate = val.transactionDate;
                    item.dueDate = val.dueDate;
                    item.transactionId = val.transactionId;
                    item.id = 0;
                    item.type = val.type;
                    this.transactions.push(item);
                });
                this.calculateTotalValue();
            });
       

    }

    goBack(): void {
        this._router.navigate(['/app/sales/customerPayments']);
    }
}
